import { render, staticRenderFns } from "./ShiftTaskContents.vue?vue&type=template&id=fd3e72c6&scoped=true&"
import script from "./ShiftTaskContents.vue?vue&type=script&lang=ts&"
export * from "./ShiftTaskContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3e72c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
